import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { FlightShopType } from "redmond";
import { FlightList } from "./component";
import { IStoreState } from "../../../../../reducers/types";
import {
  setChosenOutgoingSlice,
  setChosenReturnSlice,
} from "../../../actions/actions";
import {
  getAdultsCount,
  getChildrenCount,
  getInfantsInSeatCount,
  getInfantsOnLapCount,
} from "../../../../search/reducer";
import { flightShopTypeSelector } from "../../../reducer";

const mapStateToProps = (state: IStoreState) => ({
  isChfarExercise:
    flightShopTypeSelector(state) ===
    FlightShopType.CHANGE_FOR_ANY_REASON_EXERCISE,
  adultsCount: getAdultsCount(state),
  childrenCount: getChildrenCount(state),
  infantsOnLapCount: getInfantsOnLapCount(state),
  infantsInSeatCount: getInfantsInSeatCount(state),
});

const mapDispatchToProps = {
  setChosenReturnSlice,
  setChosenOutgoingSlice,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightListConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedFlightList = connector(withRouter(FlightList));
